/* src/app/front-layout/eleven-plus-sprint/eleven-plus-sprint.component.css */
* {
  box-sizing: border-box;
}
.hero-section {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 60px;
  max-width: 1600px;
  margin-top: 200px;
  margin-left: auto;
  margin-right: auto;
}
.nav-buttons {
  position: absolute;
  top: 40px;
  left: 60px;
  display: flex;
  gap: 15px;
  z-index: 10;
  margin-top: 100px;
}
.nav-btn {
  background: #FDB913;
  color: #1a1a1a;
  border: none;
  padding: 15px 35px;
  border-radius: 50px;
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(253, 185, 19, 0.3);
}
.nav-btn:hover {
  background: #e5a500;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(253, 185, 19, 0.4);
}
.content-left {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeInLeft 1s ease-out;
}
.main-heading {
  font-size: 7rem;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1;
  margin-bottom: 10px;
}
.sprint-text {
  font-size: 5rem;
  font-weight: 900;
  color: #0B7AB5;
  line-height: 1;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
}
.runner-icon {
  display: inline-block;
  animation: run 2s ease-in-out infinite;
}
.description {
  font-size: 1.7rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.6;
  margin-bottom: 15px;
  text-align: center;
}
.dates {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 40px;
}
.cta-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
}
.cta-button {
  background: #0B7AB5;
  color: white;
  border: none;
  padding: 20px 50px;
  border-radius: 50px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 25px rgba(25, 118, 210, 0.3);
}
.cta-button:hover {
  background: #1565C0;
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(25, 118, 210, 0.4);
}
.grid-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(200, 200, 200, 0.15) 1px, transparent 1px),
    linear-gradient(
      90deg,
      rgba(200, 200, 200, 0.15) 1px,
      transparent 1px);
  background-size: 80px 80px;
  z-index: -1;
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes run {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(10px);
  }
}
.subjects-header {
  background: #FDB913;
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ribbon-content {
  width: 100%;
  max-width: 1600px;
}
.subjects-title {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}
.icon-box {
  background: white;
  padding: 15px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-books {
  width: 50px;
  height: 50px;
}
.subjects-title h2 {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1a1a1a;
}
.subjects-list {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
}
.success-plan {
  width: 100%;
  background: white;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.section-title {
  font-size: 4rem;
  font-weight: 900;
  color: #1976D2;
  margin-bottom: 40px;
}
.plan-container {
  width: 100%;
  max-width: 1600px;
  background:
    linear-gradient(
      135deg,
      #0B7AB5 0%,
      #0B7AB5 100%);
  padding: 50px;
  border-radius: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  box-shadow: 0 10px 40px rgba(25, 118, 210, 0.3);
}
.left-column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.plan-cards-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.plan-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.card-image {
  width: 100%;
  height: 160px;
  object-fit: cover;
}
.card-content {
  padding: 20px;
}
.card-duration {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 10px;
}
.card-description {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}
.info-card {
  background: white;
  border-radius: 12px;
  padding: 25px;
  display: flex;
  gap: 20px;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.info-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
}
.info-text {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.5;
}
.info-text .highlight {
  color: #1976D2;
  font-weight: 800;
}
.right-column {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.roadmap-wrapper-main {
  max-width: 1400px;
  margin: 50px auto;
  padding: 0 20px;
}
.roadmap-header-block {
  text-align: center;
  margin-bottom: 80px;
}
.roadmap-header-block h1 {
  font-size: 4rem;
  font-weight: 900;
  color: #1a1a1a;
  line-height: 1;
  margin-bottom: 15px;
}
.roadmap-header-block p {
  font-size: 1.8rem;
  color: #333;
  line-height: 1.5;
}
.roadmap-visual-area {
  position: relative;
  min-height: 400px;
  margin-top: 50px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.roadmap-svg-path {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 1300px;
  height: 500px;
}
.roadmap-path-stroke {
  fill: none;
  stroke: #0B7AB5;
  stroke-width: 110;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.roadmap-path-dashes {
  fill: none;
  stroke: white;
  stroke-width: 6;
  stroke-dasharray: 30 25;
  stroke-linecap: round;
  stroke-linejoin: round;
  animation: roadmapFlowAnimation 3s linear infinite;
}
@keyframes roadmapFlowAnimation {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -55;
  }
}
.roadmap-icon-circle {
  position: absolute;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 5px solid white;
}
.roadmap-icon-pos1 {
  top: 50%;
  left: 8%;
  transform: translateY(-50%);
  background: #E85D75;
}
.roadmap-icon-pos2 {
  top: 15%;
  left: 32%;
  background: #E87251;
}
.roadmap-icon-pos3 {
  top: 50%;
  left: 56%;
  transform: translateY(-50%);
  background: #FDB913;
}
.roadmap-icon-pos4 {
  top: 15%;
  left: 80%;
  background: #4CAF50;
}
.roadmap-icon-circle svg {
  width: 65px;
  height: 65px;
  fill: white;
  stroke: white;
  stroke-width: 1.5;
}
.roadmap-connect-line {
  position: absolute;
  width: 2px;
  background: #A8D5E2;
  z-index: 1;
}
.roadmap-connect-line::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
}
.roadmap-connect-line1 {
  left: 12.5%;
  top: 80%;
  height: 100px;
}
.roadmap-connect-line1::after {
  bottom: -1px;
  border-top: 8px solid #A8D5E2;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.roadmap-connect-line2 {
  left: 38.5%;
  top: 40%;
  height: 250px;
}
.roadmap-connect-line2::after {
  top: -1px;
  border-bottom: 8px solid #A8D5E2;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.roadmap-connect-line3 {
  left: 60.5%;
  top: 80%;
  height: 100px;
}
.roadmap-connect-line3::after {
  bottom: -1px;
  border-top: 8px solid #A8D5E2;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.roadmap-connect-line4 {
  left: 84.5%;
  top: 40%;
  height: 250px;
}
.roadmap-connect-line4::after {
  top: -1px;
  border-bottom: 8px solid #A8D5E2;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.roadmap-content-bottom {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  padding: 0 20px;
}
.roadmap-milestone-item {
  text-align: center;
}
.roadmap-milestone-badge {
  background: #FDB913;
  color: #1a1a1a;
  padding: 12px 30px;
  border-radius: 50px;
  font-size: 1.3rem;
  font-weight: 800;
  display: inline-block;
  margin-bottom: 15px;
  box-shadow: 0 4px 15px rgba(253, 185, 19, 0.3);
}
.roadmap-milestone-heading {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.roadmap-milestone-text {
  font-size: 1.4rem;
  color: #333;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .roadmap-visual-area {
    position: static;
    min-height: auto;
    height: auto;
    margin: 20px 0;
    padding: 0;
    display: block;
  }
  .roadmap-svg-path {
    display: none;
  }
  .roadmap-icon-circle {
    position: relative;
    width: 100px;
    height: 100px;
    border: 4px solid white;
    margin: 0 auto 30px;
    top: auto;
    left: auto;
    transform: none;
    display: block;
  }
  .roadmap-icon-circle svg {
    width: 50px;
    height: 50px;
  }
  .roadmap-icon-pos1::after,
  .roadmap-icon-pos2::after,
  .roadmap-icon-pos3::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 40px;
    background: #A8D5E2;
    left: 50%;
    transform: translateX(-50%);
    bottom: -35px;
    border-radius: 2px;
  }
  .roadmap-icon-pos4::after {
    display: none;
  }
  .roadmap-connect-line {
    display: none;
  }
  .roadmap-content-bottom {
    grid-template-columns: 1fr;
    gap: 50px;
    margin-top: 30px;
  }
  .roadmap-milestone-item {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .roadmap-milestone-badge {
    font-size: 1rem;
    padding: 10px 20px;
  }
  .roadmap-milestone-heading {
    font-size: 1.4rem;
  }
  .roadmap-milestone-text {
    font-size: 1.1rem;
    max-width: 90%;
  }
}
.weekly-session-container {
  font-family: Arial, sans-serif;
  max-width: 90%;
  margin: 40px auto;
}
.header {
  background-color: #F5C542;
  padding: 30px 20px;
  margin-bottom: 0;
}
.header h1 {
  color: #1B7A9F;
  font-size: 32px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}
.sessions-grid {
  background-color: #1B7A9F;
  padding: 20px 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
.session-card {
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.week-title {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.subject-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.subject-item {
  font-size: 15px;
  color: #333333;
  line-height: 1.5;
}
.success-stories-container {
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.story-card {
  background-color: #F5F5F5;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
}
.story-content {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  align-items: flex-start;
}
.student-profile {
  flex-shrink: 0;
}
.topper-image {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
}
.story-details {
  flex: 1;
}
.student-label {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.student-name {
  color: #0B7AB5;
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 15px 0;
}
.achievement-text {
  color: #000000;
  font-size: 20px;
  line-height: 1.6;
  margin: 0;
}
.testimonial-box {
  background-color: #F5C542;
  border-radius: 8px;
  padding: 20px 25px;
  margin-bottom: 20px;
}
.testimonial-header {
  color: #000000;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}
.testimonial-text {
  color: #000000;
  font-size: 16px;
  font-style: italic;
  line-height: 1.6;
  margin: 0;
}
.closing-message {
  color: #0B7AB5;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
}
.road-map-img {
  display: none;
}
.pricing-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
  padding: 0 20px;
}
.pricing-container {
  background:
    linear-gradient(
      135deg,
      #0B5F8C 0%,
      #1B98C8 100%);
  border-radius: 12px;
  padding: 40px 30px;
  width: 100%;
  max-width: 1600px;
}
.pricing-header {
  margin-bottom: 40px;
}
.pricing-title {
  color: #FFFFFF;
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 10px 0;
}
.price-info {
  color: #FFFFFF;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 5px;
}
.price-description {
  color: #F5C542;
  font-size: 20px;
  font-weight: 500;
}
.pricing-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
}
.pricing-card {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  height: 100%;
}
.plan-header {
  background-color: #F5C542;
  padding: 25px 20px;
  text-align: center;
  flex-shrink: 0;
}
.plan-weeks {
  color: #000000;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 5px;
}
.plan-label {
  color: #000000;
  font-size: 16px;
  font-weight: 600;
}
.features-list {
  list-style: none;
  padding: 25px 20px;
  margin: 0;
  flex-grow: 1;
}
.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333333;
}
.feature-item:last-child {
  margin-bottom: 0;
}
.check-icon {
  color: #0B7AB5;
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background-color: #E8F4F8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feature-text {
  line-height: 1.4;
}
.discount-badge {
  background-color: #F5C542;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 8px;
  margin: 0 20px 15px 20px;
  border-radius: 6px;
  flex-shrink: 0;
}
.discount-badge .original-price {
  text-decoration: line-through;
  margin-right: 5px;
}
.pricing-buttons {
  display: flex;
  gap: 10px;
  margin: 0 20px 20px 20px;
  flex-shrink: 0;
}
.price-display {
  background-color: #0B7AB5;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  padding: 12px;
  flex: 0 0 auto;
  min-width: 80px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buy-now-button {
  background-color: #4CAF50;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s ease;
}
.buy-now-button:hover {
  background-color: #45a049;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);
}
@media (max-width: 1200px) {
  .hero-section {
    padding: 40px;
    margin: 150px auto;
  }
  .nav-buttons {
    left: 40px;
    top: 30px;
  }
  .main-heading {
    font-size: 5rem;
  }
  .sprint-text {
    font-size: 4rem;
  }
  .plan-container {
    grid-template-columns: 1fr;
  }
  .plan-cards-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .roadmap-content-bottom {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .hero-section {
    padding: 30px 25px;
    margin: 120px auto;
  }
  .nav-buttons {
    left: 25px;
    top: 20px;
    gap: 10px;
  }
  .nav-btn {
    padding: 10px 20px;
    font-size: 1rem;
  }
  .main-heading {
    font-size: 4rem;
  }
  .sprint-text {
    font-size: 3rem;
  }
  .description,
  .dates {
    font-size: 1.3rem;
  }
  .cta-button {
    padding: 16px 40px;
    font-size: 1.2rem;
  }
  .subjects-header {
    padding: 30px 25px;
  }
  .section-title {
    font-size: 3rem;
  }
  .sessions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .hero-section {
    margin: 100px auto 50px;
    padding: 20px 15px;
    height: 100vh;
  }
  .nav-buttons {
    position: relative;
    top: 0;
    left: 0;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
  .nav-btn {
    padding: 10px 18px;
    font-size: 0.85rem;
  }
  .content-left {
    width: 100%;
  }
  .main-heading {
    font-size: 3.5rem;
  }
  .sprint-text {
    font-size: 2.5rem;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .runner-icon svg {
    width: 40px;
    height: 40px;
  }
  .description {
    font-size: 1.1rem;
  }
  .dates {
    font-size: 1.5rem;
  }
  .cta-buttons {
    width: 100%;
  }
  .cta-button {
    padding: 14px 30px;
    font-size: 1rem;
    width: 100%;
  }
  .subjects-title {
    flex-direction: column;
    text-align: center;
  }
  .subjects-title h2 {
    font-size: 1.5rem;
  }
  .subjects-list {
    font-size: 1.2rem;
    text-align: center;
  }
  .success-plan {
    padding: 40px 20px;
  }
  .section-title {
    font-size: 2.5rem;
  }
  .plan-container {
    padding: 30px 20px;
  }
  .plan-cards-row {
    grid-template-columns: 1fr;
  }
  .card-duration {
    font-size: 1.5rem;
  }
  .card-description {
    font-size: 1.2rem;
  }
  .info-card {
    flex-direction: column;
    text-align: center;
  }
  .info-text {
    font-size: 1.5rem;
  }
  .roadmap-wrapper-main {
    margin: 30px auto;
    padding: 0 15px;
    display: none;
  }
  .roadmap-header-block {
    margin-bottom: 40px;
  }
  .roadmap-header-block h1 {
    font-size: 2.5rem;
  }
  .roadmap-header-block p {
    font-size: 1.2rem;
  }
  .header h1 {
    font-size: 28px;
  }
  .sessions-grid {
    grid-template-columns: 1fr;
  }
  .story-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .topper-image {
    width: 150px;
    height: 150px;
  }
  .student-name {
    font-size: 24px;
  }
  .closing-message {
    font-size: 20px;
  }
  .pricing-main {
    margin-top: 80px;
  }
  .pricing-container {
    padding: 30px 20px;
  }
  .pricing-title {
    font-size: 30px;
  }
  .price-info {
    font-size: 24px;
  }
  .price-description {
    font-size: 18px;
  }
  .pricing-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
@media (max-width: 480px) {
  .hero-section {
    margin-top: 80px;
    margin-left: auto;
    margin-right: auto;
    padding: 15px 10px;
    height: 100vh;
  }
  .nav-btn {
    padding: 8px 15px;
    font-size: 0.75rem;
  }
  .main-heading {
    font-size: 2.8rem;
  }
  .sprint-text {
    font-size: 2rem;
  }
  .runner-icon svg {
    width: 30px;
    height: 30px;
  }
  .description {
    font-size: 1rem;
  }
  .dates {
    font-size: 1.3rem;
    margin-bottom: 30px;
  }
  .cta-button {
    padding: 12px 25px;
    font-size: 0.9rem;
  }
  .subjects-header {
    padding: 25px 15px;
  }
  .icon-box {
    padding: 10px;
  }
  .icon-books {
    width: 35px;
    height: 35px;
  }
  .subjects-title h2 {
    font-size: 1.3rem;
  }
  .subjects-list {
    font-size: 1rem;
  }
  .success-plan {
    padding: 30px 15px;
  }
  .section-title {
    font-size: 2rem;
  }
  .plan-container {
    padding: 20px 15px;
  }
  .card-image {
    height: 140px;
  }
  .card-content {
    padding: 15px;
  }
  .card-duration {
    font-size: 1.3rem;
  }
  .card-description {
    font-size: 1rem;
  }
  .info-card {
    padding: 20px;
  }
  .info-image {
    width: 100px;
    height: 100px;
  }
  .info-text {
    font-size: 1.2rem;
  }
  .roadmap-wrapper-main {
    padding: 0 10px;
    display: none;
  }
  .road-map-img {
    display: flex;
    width: 100%;
    padding: 10px;
    align-items: center;
  }
  .road-map-img img {
    width: 100%;
    height: 350px;
    object-fit: contain;
  }
  .roadmap-header-block h1 {
    font-size: 2rem;
  }
  .roadmap-header-block p {
    font-size: 1rem;
  }
  .roadmap-visual-area {
    min-height: 850px;
  }
  .roadmap-svg-path {
    width: 95vw;
    max-width: 350px;
    height: 750px;
  }
  .roadmap-path-stroke {
    stroke-width: 70;
  }
  .roadmap-icon-circle {
    width: 70px;
    height: 70px;
  }
  .roadmap-icon-circle svg {
    width: 35px;
    height: 35px;
  }
  .roadmap-icon-pos1 {
    top: 90px;
  }
  .roadmap-icon-pos2 {
    top: 270px;
  }
  .roadmap-icon-pos3 {
    top: 450px;
  }
  .roadmap-icon-pos4 {
    top: 630px;
  }
  .roadmap-content-bottom {
    gap: 35px;
  }
  .roadmap-milestone-badge {
    font-size: 0.9rem;
    padding: 8px 16px;
  }
  .roadmap-milestone-heading {
    font-size: 1.2rem;
  }
  .roadmap-milestone-text {
    font-size: 1rem;
  }
  .weekly-session-container {
    max-width: 95%;
  }
  .header {
    padding: 25px 15px;
  }
  .header h1 {
    font-size: 24px;
  }
  .sessions-grid {
    padding: 15px 10px;
  }
  .session-card {
    padding: 15px;
  }
  .week-title {
    font-size: 18px;
  }
  .subject-item {
    font-size: 14px;
  }
  .success-stories-container {
    padding: 30px 15px;
  }
  .section-title {
    font-size: 2rem;
  }
  .story-card {
    padding: 20px;
  }
  .topper-image {
    width: 120px;
    height: 120px;
  }
  .student-name {
    font-size: 20px;
  }
  .achievement-text {
    font-size: 16px;
  }
  .testimonial-box {
    padding: 15px 20px;
  }
  .testimonial-header {
    font-size: 16px;
  }
  .testimonial-text {
    font-size: 14px;
  }
  .closing-message {
    font-size: 18px;
  }
  .pricing-main {
    margin-top: -200px;
    padding: 0 10px;
  }
  .pricing-container {
    padding: 25px 15px;
  }
  .pricing-title {
    font-size: 26px;
  }
  .price-info {
    font-size: 20px;
  }
  .price-description {
    font-size: 16px;
  }
  .plan-weeks {
    font-size: 24px;
  }
  .plan-label {
    font-size: 14px;
  }
  .features-list {
    padding: 20px 15px;
  }
  .feature-item {
    font-size: 13px;
  }
  .discount-badge {
    font-size: 13px;
    margin: 0 15px 12px 15px;
  }
  .pricing-buttons {
    margin: 0 15px 15px 15px;
  }
  .price-display {
    font-size: 18px;
    min-width: 70px;
  }
  .buy-now-button {
    font-size: 14px;
    padding: 10px 15px;
  }
}
@media (max-width: 360px) {
  .main-heading {
    font-size: 2.5rem;
  }
  .sprint-text {
    font-size: 1.8rem;
  }
  .description {
    font-size: 0.9rem;
  }
  .cta-button {
    padding: 10px 20px;
    font-size: 0.85rem;
  }
  .roadmap-header-block h1 {
    font-size: 1.8rem;
  }
  .roadmap-svg-path {
    height: 700px;
  }
  .roadmap-icon-pos1 {
    top: 80px;
  }
  .roadmap-icon-pos2 {
    top: 250px;
  }
  .roadmap-icon-pos3 {
    top: 420px;
  }
  .roadmap-icon-pos4 {
    top: 590px;
  }
  .section-title {
    font-size: 1.8rem;
  }
}
@media (max-height: 500px) and (orientation: landscape) {
  .hero-section {
    margin: 50px auto;
    min-height: auto;
  }
  .nav-buttons {
    margin-top: 20px;
  }
  .main-heading {
    font-size: 2.5rem;
  }
  .sprint-text {
    font-size: 2rem;
  }
  .description {
    font-size: 1rem;
  }
  .dates {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
}
@media print {
  .nav-buttons,
  .cta-buttons,
  .buy-now-button {
    display: none;
  }
  .hero-section {
    page-break-after: always;
  }
}
/*# sourceMappingURL=eleven-plus-sprint.component.css.map */
